import { API_URL } from "../../../config";
import { axios } from "../../../lib/axios";


export const sendOtp = async (params:any) => {
    return axios.post(`https://api-cb.commbitz.com/otp/send`, params);
}

export const otpVeriFy = async (params:any) => {
    return axios.post(`https://api-cb.commbitz.com/otp/verify`, params);
}

    export const createUser = async (params:any) => {
        return axios.post(`https://api-cb.commbitz.com/create-globalytics-user`, params, {
            headers: {
                Partnerwebsiteid: "6719f9721bba1b02d47447af"
            }
        });
    }

export const getCart = async (id:string) => {
    return axios.get(`https://api-cb.commbitz.com/globalytics/carts/${id}`, {
        headers: {
          Partnerwebsiteid: "6719f9721bba1b02d47447af" 
        }
      });
}
export const stripePaymentIntent = async ( params: any) => {
    return await axios.post(`https://api-cb.commbitz.com/stripe/paymentIntent`, params);
};

export const getFilter = async (params:any, partnershipId: string) => {
    return axios.get(`https://api-cb.commbitz.com/globalytics/esim-plan/filter`, {params,
        headers: {
        //   Partnerwebsiteid: partnershipId
        }});
}
export const addToCart = async (id:string, items:any) => {
    return axios.put(`https://api-cb.commbitz.com/globalytics/carts/${id}`, items);
}


export const createOrder = async (params:any) => {
    return axios.post(`https://api-cb.commbitz.com/globalytics-order`, params);
}


export const razorpayPaymentIntent = async ( params: any) => {
    return await axios.post(`https://api-cb.commbitz.com/razorpay/order`, params);
};

export const purchaseOrder = async (params: any, partnershipId: string): Promise<any> => {
    return axios.post(
        `https://api-cb.commbitz.com/order/purchaseZeroPriceOrder`,
        params,
        {
            headers: {
                Partnerwebsiteid: partnershipId
            }
        }
    );
};